import { designTokens, styled } from '@project44/manifest-ds';

export const StyledTooltipOverlay = styled('div', {
  background: '#fff',
  borderRadius: 'large',
  color: 'black',
  fontWeight: 'normal',
  position: 'absolute',
  padding: '12px',
  filter:
    'drop-shadow(rgb(233, 233, 247) 0px 0px 1px) drop-shadow(rgb(227, 227, 243) 1px 3px 3px)',
  cursor: 'default',
  maxWidth: '360px',
  zIndex: designTokens.zIndexPopover,
});

export const TitleContainer = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontSize: 'small',
  fontWeight: 'bold',
});

export const CloseContainer = styled('div', {
  display: 'flex',
  marginLeft: '16px',
  fontSize: 'small',
  cursor: 'pointer',
  width: '12px',
  height: '12px',
});

export const ContentContainer = styled('span', {
  fontSize: 'x-small',
});
